"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class LocalConsoleInstance {
    domain = [""];
    console;
    constructor() {
        if (process.env.NODE_ENV !== "production") {
            this.console = console;
        }
        if (process.env.NODE_ENV === "production") {
            delete this.console;
        }
        return this;
    }
    // log(): void
    blueLog = (...data) => {
        let output = [];
        if (typeof data[0] === "object") {
            output = ["%cobject:", "background: #64b7ff99; color: #fff;", data[0]];
            if (data.length > 1) {
                for (const item of data.slice(1)) {
                    output.push("%c" + item, "background: #64b7ff99; color: #fff;");
                }
            }
        }
        else {
            for (const item of data) {
                output.push(`%c${item}`, "background: #64b7ff99; color: #fff;");
            }
        }
        this.console?.log(...output);
    };
}
const instance = new LocalConsoleInstance();
const _console = instance?.console;
const localConsoleExtends = () => {
    if (_console) {
        let obj = {
            ..._console,
            blueLog: instance.blueLog,
        };
        return obj;
    }
    return undefined;
};
const localConsole = localConsoleExtends();
exports.default = localConsole;
